import React, { useEffect, useState, useRef } from 'react';
import SlickNextArrow from '../../../common/slicknext';
import SlickPrevArrow from '../../../common/slickprev';
import Slider from 'react-slick';
import { removeSpecialCharacters } from '../../../GlobalFunctions';
import { poweredBy } from '../../../api/baseUrl';
import ReactApexChart from 'react-apexcharts';

export default function Chart({ section, data, index, company, key2 }) {
  let compId = company;
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);

  const chartName = data.label;

  const ChartColors = [
    '#0B254A',
    '#3969D5',
    '#B7CD5E',
    '#717375',
    '#D2E5FF',
    '#0B254A',
    '#3969D5',
    '#B7CD5E',
    '#717375',
    '#D2E5FF',
  ];

  useEffect(() => {
    generateChart();
  }, [company.id, data.data]);

  const generateChart = () => {
    const years = data.data.map((d) => d.year);
    const values = data.data.map((d) => d.value);

    const options = {
      chart: {
        id: `apexchart-${section}-${data.label}-${index}`,
        type: 'bar',
        toolbar: {
          tools: {
            download: true,
          },
          export: {
            csv: {
              filename: data.label,
            },
            svg: {
              filename: data.label,
            },
            png: {
              filename: data.label,
            },
          },
        },
      },
      xaxis: {
        categories: years,
        labels: {
          rotate: -90,
          style: {
            colors: '#626768',
            fontSize: '11px',
          },
        },
        title: {
          text: data.label,
          offsetX: 0,
          offsetY: -330,
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            // color: '#000',
          },
        },
      },
      yaxis: {
        labels: {
          formatter: function (value) {
            return Number(value).toLocaleString('en-US');
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 0,
          horizontal: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        width: 0,
      },
      fill: {
        colors: [ChartColors[index]],
      },
      annotations: {
        images: [
          {
            path: poweredBy,
            x: "60%",
            y: "85%",
            width: 120,
            height: 65,
          },
        ],
      },
      grid: {
        xaxis: {
          lines: {
            show: false,
          },
        },
        yaxis: {
          lines: {
            show: false,
          },
        },
        padding: {
          bottom: -10,
        },
      },
    };

    const series = [
      {
        name: data.label,
        data: values,
      },
    ];

    setChartOptions(options);
    setChartSeries(series);
  };

  return (
    <div key={`${data.label}_${index}`} id="chats-short-bg">
      <p className="chart-title">
        {data.label}
        <span style={{ fontSize: '11px', marginLeft: '3px' }}>
          {data.unit ? `(${data.unit})` : null}
        </span>
      </p>
      <div
        id={removeSpecialCharacters(`${section}_${data.label}_${index}`)}
        className="chart-block"
        key={key2}
      >
        <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={350} />
      </div>
    </div>
  );
}